import { useState } from 'react';

interface HeroProps {
  onSearch: (keyword: string) => void;
}

const hotWords = ['自习室一哥', '班长点名册', '食堂阿姨弹琴', '毕业照黑历史', '反差学霸'];

export default function Hero({ onSearch }: HeroProps) {
  const [kw, setKw] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(kw.trim());
  };

  return (
    <section className="relative overflow-hidden border-b border-cream-200 bg-cream-100">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -left-16 top-10 h-64 w-64 rounded-full bg-primary-100 opacity-70" />
      <div className="pointer-events-none absolute -right-10 bottom-0 h-72 w-72 rounded-full bg-accent-100 opacity-60" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-40 rounded-full bg-secondary-100 opacity-50" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 py-10 md:px-6 md:py-16 lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-cream-50">
            <i className="ri-fire-line" />
            全网校园吃瓜 · 每日更新
          </span>
          <h1 className="font-display mt-5 text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl">
            校园里的每一件小事，
            <br />
            都值得<span className="text-primary-500">上热搜</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink-600">
            我们专注盘点<span className="font-bold text-primary-700">校园风云人物爆料</span>、班长学委的
            <span className="font-bold text-primary-700">秘密合集</span>、
            <span className="font-bold text-primary-700">社团名场面</span>，以及那些让人惊呼
            <span className="font-bold text-primary-700">「反差」</span>的瞬间——把身边同学的高光与名场面，
            讲成一篇篇有料又有梗的校园盘点。
          </p>

          <form onSubmit={submit} className="mt-6 flex w-full max-w-xl items-center gap-0 overflow-hidden rounded-full border border-cream-300 bg-white p-1 shadow-soft">
            <input
              type="text"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜风云人物、班长学委、社团名场面…"
              className="flex-1 border-0 bg-transparent px-4 text-sm outline-none placeholder:text-ink-700"
              aria-label="站内搜索"
            />
            <button
              type="submit"
              className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-cream-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line" />
              搜一搜
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center gap-2 text-sm">
            <span className="text-ink-600">今日热点：</span>
            {hotWords.map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => {
                  setKw(w);
                  onSearch(w);
                }}
                className="whitespace-nowrap rounded-full bg-white px-3 py-1 text-xs text-ink-600 transition-colors hover:bg-accent-200 hover:text-ink"
              >
                #{w}
              </button>
            ))}
          </div>
        </div>

        <div className="relative hidden lg:block">
          <div className="overflow-hidden rounded-[2rem] border-4 border-white shadow-soft">
            <img
              src="https://readdy.ai/api/search-image?query=Playful%20flat%20vector%20illustration%20of%20a%20crowd%20of%20energetic%20college%20students%20surrounding%20a%20loudspeaker%20with%20speech%20bubbles%2C%20cameras%20and%20sparkles%2C%20memphis%20style%20bursts%20in%20warm%20coral%20amber%20and%20rose%20palette%2C%20editorial%20magazine%20zine%20style%2C%20clean%20cream%20background%2C%20fun%20campus%20gossip%20energy&width=720&height=520&seq=hero-campus&orientation=landscape"
              alt="一群充满活力的校园学生围观热点的插画"
              className="w-full object-cover"
            />
          </div>
          <span className="absolute -left-4 top-6 flex -rotate-6 items-center gap-1 rounded-full bg-secondary-500 px-3 py-1.5 text-xs font-bold text-cream-50">
            <i className="ri-sparkling-2-line" />
            名场面在线
          </span>
          <span className="absolute -right-2 bottom-8 flex rotate-3 items-center gap-1 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-bold text-ink">
            <i className="ri-fire-fill" />
            今日 6 条爆款
          </span>
        </div>
      </div>
    </section>
  );
}